
import { Component, Mixins, Prop, Emit, Inject } from "vue-property-decorator";
import { namespace } from "vuex-class";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { IAccount } from "@/modules/auth/types";
import { EServices } from "@/types";
import KycClient from "../services/KycClient";

const AccountModule = namespace("AccountModule");

@Component({})
export default class KycDialog extends Mixins(JackocoinsNetworkManagerMixin) {
  @Prop(Boolean) showDialog!: boolean;

  @Emit("close-dialog")
  closeKycDialog() {}

  @AccountModule.State
  account!: IAccount;

  @Inject(EServices.kyc)
  kycClient!: KycClient;

  get widgetUrl(): string {
    return `
    https://identity.dojah.io?widget_id=${
      process.env.VUE_APP_DOJAH_WIDGET_ID
    }&user_data[first_name]=${this.account.firstName}
    &user_data[middle_name]=${""}&user_data[last_name]=${this.account.lastName}
    &user_data[dob]=${""}&metadata[user_id]=${this.account.id}
    `;
  }
}
